import { render, staticRenderFns } from "./ClinicAddCard.vue?vue&type=template&id=52783794&scoped=true&"
import script from "./ClinicAddCard.vue?vue&type=script&lang=js&"
export * from "./ClinicAddCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52783794",
  null
  
)

export default component.exports